export const entityTypes = {
  DOCUMENT: "Document",
  PARTNER: "Partner",
  ASSET: "Asset"
};

export const docTypes = {
  PRINT: "Print",
  ATTACHMENT: "Attchment"
};
